import {useQuery} from "@apollo/client";
import {GetCategories} from "./Category.js";

export function useGetCategories(params = {}) {
    const {data, previousData, loading, error, refetch, variables} = useQuery(
        GetCategories,
        {...params, notifyOnNetworkStatusChange: true}
    );
    
    let holder = (data && data['GetCategories']) ? data : previousData;
    const extracted = (holder) ? holder['GetCategories'] : [];

    if(error) console.log(error);

    return {
        data: extracted, 
        loading: (loading && !previousData), 
        refetch, 
        variables,
        error: error
                ? <div className="bg-red-600 text-white px-4 py-2 mt-1 rounded-md">{error?.message}</div>
                : null
    }
}
export async function asyncGetCategories(variables = {}, apolloClient) {
    const {data, loading} = await apolloClient.query({
        query: GetCategories,
        variables
    });
    const extracted = data ? data['GetCategories'] : [];
    return {
        data: extracted,
        loading: loading,
        variables
    }
}
